import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const REGISTRATION_URL = "https://in.njuko.com/pasteur-century-run1772850040777?currentPage=select-competition";

const TSHIRT_IMAGE = "https://images.pexels.com/photos/12039633/pexels-photo-12039633.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function HeroSection() {
  return (
    <section data-testid="hero-section" className="relative px-4 sm:px-6 pt-8 pb-4 max-w-7xl mx-auto">
      {/* Clínica Pasteur badge */}
      <motion.div
        initial={{ opacity: 0, y: 15 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2, duration: 0.5 }}
        className="text-center mb-4"
      >
        <div className="inline-flex items-center justify-center mb-2">
          <img
            src="https://customer-assets.emergentagent.com/job_runner-hub-20/artifacts/iqhsc4ka_clinicas_Dra5-1024x576%202.png"
            alt="Clínica Pasteur"
            className="h-12 sm:h-16 w-auto object-contain"
            fetchpriority="high"
          />
        </div>
        <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl text-[#0F0F10] font-light italic">
          Carrera Atletica
        </h2>
      </motion.div>

      {/* T-shirt image */}
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ delay: 0.4, duration: 0.7 }}
        className="flex justify-center mb-6"
      >
        <img
          data-testid="hero-tshirt-image"
          src="https://customer-assets.emergentagent.com/job_runner-hub-20/artifacts/vm0ke5v5_camiseta%201.png"
          alt="Camiseta oficial Pasteur Century Run 100"
          className="max-w-[200px] sm:max-w-sm lg:max-w-md w-full h-auto object-contain"
          fetchpriority="high"
        />
      </motion.div>

      {/* CTA Comprar Button */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.6, duration: 0.5 }}
        className="flex justify-center mb-8 -mt-6"
      >
        <a
          data-testid="comprar-btn"
          href={REGISTRATION_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="cta-comprar group inline-flex items-center gap-4 bg-[#242424] text-white rounded-full pl-6 pr-4 py-3 sm:py-4 shadow-2xl hover:shadow-[0_20px_60px_rgba(196,161,94,0.3)] transition-all duration-500 hover:scale-[1.02]"
        >
          <img
            src="https://customer-assets.emergentagent.com/job_runner-hub-20/artifacts/6epk0lbx_run%20100.png"
            alt="RUN 100~"
            className="h-8 sm:h-10 w-auto object-contain"
          />
          <div className="h-8 w-px bg-white/20" />
          <div className="flex items-center gap-2">
            <div>
              <span className="text-[10px] text-white font-body font-medium block leading-none">5/10 km</span>
              <span className="text-lg sm:text-xl font-body font-semibold">Comprar</span>
            </div>
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </div>
        </a>
      </motion.div>
    </section>
  );
}
